import { Component, Injectable, OnInit, Input, Compiler } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { AuthenticationService } from '../../../../app/services/authentication.service';
import { AlertService } from '../../../../app/utils/alert.service';
import { BindComponentService } from '../../../utils/bind.component.service';

/**
 * this.author Thiago Neri
 * @version $Id: content.component.ts 62312 2017-09-12 17:39:13Z bernardo.d.siqueira $
 */
@Component({
  selector: 'loading',
  //templateUrl: 'app/home/paraEmpresas/modalLoading/content.modal.template.html'
  template: '  <div class="loading"><div class="loader"></div></div>'
})
@Injectable()
export class LoadingComponent implements OnInit {

  private isLoading: boolean = true;

  constructor(private bindComponent: BindComponentService,
    private activeModal: NgbActiveModal,
    private authService: AuthenticationService,
    private alertService: AlertService) {

  }

  ngOnInit() {
    this.bindComponent.subscribe(BindComponentService.OPEN_MODAL_LOADING,
      condicao => {
        this.isLoading = condicao;
        if (!this.isLoading) {
          this.close();
        }
      }
    );
  }

  private close() {
    this.activeModal.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/modalLoading/content.component.ts